import React from "react";
import { Link, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import securweave from "../Images/securweave logo png file (8).png";
import { useDashboard } from "../contexts/DashboardContext";
import axios from "axios";

const Navbar = () => {
  let location = useLocation();
  const {
    authenticated,
    setAuthenticated,
    setSelectedValue,
    setSelectedCustomerId,
    setSelectedSystemId,
    admin,
    setAdmin,
  } = useDashboard();
  let token = Cookies.get("token");
  let customerid = Cookies.get("customerid");

  const data = `CHESS Version 1.0
https://chess-ams.securweave.com/api/
${customerid}
${token}
`;

  const downloadFile = async () => {
    try {
      const licenseType = "chess";

      const res = await axios.post(
        "/api/license/encrypt",
        {
          content: data,
          filename: "chess.lic",
          licenseType, 
        },
        {
          headers: { "x-auth-token": token },
          responseType: "blob", 
        },
      );

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const element = document.createElement("a");
      element.href = url;
      element.download = "chess.lic"; 
      document.body.appendChild(element);
      element.click();
      element.remove();
    } catch (err) {
      console.error("License download failed", err);
    }
  };

  return (
    <>
      <div className="header">
        <div className="logo">
          <img alt="SecurWeave logo" src={securweave} />
        </div>
        <div className="header_links">
          {authenticated && location.pathname === "/dashboard" && (
            <>
              <>
                {!admin && location.pathname === "/dashboard" && (
                  <>
                    <Link to="#" className="link" onClick={downloadFile}>
                      Download your key
                    </Link>
                    <Link to="/addsystem" className="link bb">
                      Generate System Key
                    </Link>
                  </>
                )}
              </>
              {location.pathname === "/dashboard" && admin && (
                <>
                  <Link to="/addlicensetype" className="link bb">
                    Add License Type
                  </Link>
                  <div className="link drop customerinfo">
                    <small>Customer Information</small>
                    <div className="mbox customerinfocontent">
                      <Link to="/addcustomer" className="bb">
                        <small className="icon">&#10010;</small> &nbsp; Add
                        Customer
                      </Link>
                      <Link to="/addlicense">
                        <small className="icon">&#x1F511;</small> &nbsp; Add
                        License
                      </Link>
                    </div>
                  </div>
                </>
              )}
              <Link
                className="link"
                to="/"
                onClick={() => {
                  Cookies.remove("token");
                  Cookies.remove("role");
                  Cookies.remove("customerid");
                  Cookies.remove("username");
                  Cookies.remove("gtoken");
                  setAuthenticated(false);
                  setSelectedValue("");
                  setSelectedCustomerId("");
                  setSelectedSystemId("");
                  setAdmin(false);
                }}
              >
                <small className="icon">&#xF08B;</small> &nbsp; Logout
              </Link>
            </>
          )}
          <div className="link drop">
            <small className="icon">&#xF142;</small>
            <div className="mbox">
              <a href="#contact" className="bb">
                <small className="icon">&#xF0E0;</small> &nbsp; Contact Us
              </a>
              <a href="#help">
                <small className="icon">&#xF059;</small> &nbsp; Help
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
